const message = {
  hello: 'Hello {name}',
  evolution: 'Evolution',
  from: 'From',
  to: 'To',
  vitamins: 'Vitamins',
  for: 'For',
  current: 'Current',
  current_value: 'Current value',
  team: 'Team',
  average: 'Average',
  median: 'Median',
  company: 'Company',
  score: 'Score',
  new: 'New',
  activity_log: 'Activity log',
  dashboard: 'Dashboard',
  sign_out: 'Sign out',
  preferences: 'Preferences',
  light_mode: 'Light mode',
  dark_mode: 'Dark mode',
  manager: 'Manager',
  hr: 'HR',
  company_settings: 'Company settings',
  continue: 'Continue',
  no: 'No',
  finalized: 'Finalized',
  reviewed: 'Reviewed',
  draft: 'Draft',
  show_previous_score: 'Show previous score',
  next_page: 'Next page',
  previous_page: 'Previous page',
  save_draft: 'Save draft',
  finalize: 'Finalize',
  current_score: 'Current score',
  previous_score: 'Previous score',
  team_average: 'Team average',
  company_average: 'Company average',
  comments_questions: 'Comments/questions',
  overview: 'Overview',
  step: 'Step',
  introduction: 'Introduction',
  please_complete_the_following_steps_to_begin: 'Please complete the following steps to begin.',
  next: 'Next',
  back: 'Back',
  previous: 'Previous',
  skip_setup: 'Skip setup',
  server_setup: 'Server setup',
  server_url: 'Server URL',
  port: 'Port',
  test_connection: 'Test connection',
  connection_ok: 'Connection ok!',
  my_profile: 'My profile',
  personal: 'Personal',
  contact: 'Contact',
  account: 'Account',
  tags: 'Tags',
  perks: 'Perks',
  first_name: 'First name',
  last_name: 'Last name',
  birthdate: 'Birthdate',
  gender: 'Gender',
  marital_state: 'Marital state',
  degree: 'Degree',
  education: 'Degree',
  mode_of_transportation: 'Mode of transportation',
  add_child: 'Add child',
  child_name: 'Child name',
  age: 'Age',
  actions: 'Actions',
  save_user: 'Save user',
  male: 'Male',
  female: 'Female',
  other: 'Other',
  not_married: 'Not married',
  married: 'Married',
  divorced: 'Divorced',
  widowed: 'Widowed',
  choose: 'Choose',
  primary: 'Primary',
  secondary: 'Secondary',
  bachelor: 'Bachelor',
  master: 'Master',
  doctorate: 'Doctorate',
  car: 'Car',
  bike: 'Bike',
  foot: 'Foot',
  public_transportation: 'Public transportation',
  in_family: 'In family',
  choose_a_status: 'Choose a status',
  active: 'Active',
  archived: 'Archived',
  yes: 'Yes',
  street: 'Street',
  number: 'Number',
  bus: 'Bus',
  zip_postal_code: 'Zip/postal code',
  city: 'City',
  country: 'Country',
  email: 'E-mail',
  change_password: 'Change password',
  confirm_password: 'Confirm password',
  user_is_finalized: 'User is finalized',
  select_to_add_a_tag: 'Select to add a tag',
  select_to_add_a_perk: 'Select to add a perk',
  tag: 'Tag',
  perk: 'Perk',
  description: 'Description',
  log_in: 'Log in',
  company_details: 'Company details',
  company_info: 'Company info',
  company_name: 'Company name',
  company_logo: 'Company logo',
  user_settings: 'User settings',
  save_company: 'Save company',
  cancel: 'Cancel',
  save: 'Save',
  create_new_tag: 'Create new tag',
  create_a_new_perk: 'Create new perk',
  main_user_account: 'Main user account',
  company_setup: 'Company setup',
  information: 'Information',
  logo: 'Logo',
  complete_setup: 'Complete setup',
  you: 'You',
  filter: 'Filter',
  operator: 'Operator',
  and: 'And',
  or: 'Or',
  not: 'Not',
  add_filter: 'Add filter',
  clear: 'Clear',
  equals: 'Equals',
  does_not_equal: 'Does not equal',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  is_less_than: 'Is less than',
  is_more_than: 'Is more than',
  is_near: 'Is near',
  choose_a_field: 'Choose a field',
  score_difference_from_company: 'Score difference from company',
  score_difference_from_team: 'Score difference from team',
  role: 'Role',
  lowest: 'Lowest',
  highest: 'Highest',
  start_of_employment: 'Start of employment',
  end_of_employment: 'End of employment',
  reason_for_termination: 'Reason for termination',
  team_fields: 'Team fields',
  user_fields: 'User fields',
  title: 'Title',
  seniority: 'Seniority',
  mode_of_transport: 'Mode of transport',
  children: 'Children',
  value: 'Value',
  user_list: 'User list',
  first: 'First',
  last: 'Last',
  last_evaluation: 'Last evaluation',
  team_overview: 'Team overview',
  add_team: 'Add team',
  saved_filters: 'Saved filters',
  users: 'Users',
  edit_team: 'Edit team',
  image: 'Image',
  team_name: 'Team name',
  parent_team: 'Parent team',
  managed_by: 'Managed by',
  members: 'Members',
  close: 'Close',
  add_team_manager: 'Add team manager',
  add_team_member: 'Add team member',
  professional: 'Professional',
  employment: 'Employment',
  add_user: 'Add user',
  posted_draft: 'Posted new draft submission',
  posted_final: 'Posted new final submission',
  reviewed_submission: 'Reviewed submission',
  edited_company: 'Edited company',
  edited_user: 'Edited user',
  edited_team: 'Edited team',
  edited_team_members: 'Edited team members',
  added_team_member: 'Added team member',
  removed_team_member: 'Removed team member',
  created_team: 'Created team',
  added_child: 'Added child',
  create_a_team: 'Create a team',
  drop_your_image_here: 'Drop your image here',
  none: 'None',
  testing: 'Testing',
  password: 'Password',
  cannot_be_empty: 'cannot be empty',
  email_is_not_valid: 'Email is not valid',
  password_needs_to_be_at_least_characters_long: 'Password needs to be at least {length} characters long',
  passwords_do_not_match: 'Passwords do not match',
  target_server_full: 'Target server already contains users. Cannot create new main user.',
  reset_password: 'Password reset',
  confirm_reset: 'Confirm',
  this_page_does_not_exist: 'This page does not exist.',
  back_to_homepage: 'Back to the website',
  forgot_your_password: 'Forgot your password?',
  team_score: 'Team score',
  company_score: 'Company score',
  saved_filter: 'Saved filter',
  created_user: 'Created user',
  edited_child: 'Edited child',
  type_delete_to_confirm: 'Type \'DELETE\' to confirm',
  delete_team: 'Delete team',
  warning_this_cannot_be_undone: 'WARNING: this cannot be undone',
  firstname: 'First name',
  lastname: 'Last name',
  manage_users: 'Manage users',
  name: 'Name',
  submit: 'Send',
  please_wait: 'Please wait',
  vitamins_are_being_loaded: 'Your submissions are being processed',
  is_finalized: 'Is finalized',
  back_to_login: 'Back to login',
  reset_mail_sent: 'Reset mail has been sent',
  no_submissions_yet: 'You have no vitamins yet',
  start_first_vitamin: 'Submit your first vitamins',
  country_AD: 'Andorra',
  country_AE: 'United Arab Emirates',
  country_AF: 'Afghanistan',
  country_AG: 'Antigua and Barbuda',
  country_AI: 'Anguilla',
  country_AL: 'Albania',
  country_AM: 'Armenia',
  country_AO: 'Angola',
  country_AQ: 'Antarctica',
  country_AR: 'Argentina',
  country_AS: 'American Samoa',
  country_AT: 'Austria',
  country_AU: 'Australia',
  country_AW: 'Aruba',
  country_AX: 'Åland Islands',
  country_AZ: 'Azerbaijan',
  country_BA: 'Bosnia and Herzegovina',
  country_BB: 'Barbados',
  country_BD: 'Bangladesh',
  country_BE: 'Belgium',
  country_BF: 'Burkina Faso',
  country_BG: 'Bulgaria',
  country_BH: 'Bahrain',
  country_BI: 'Burundi',
  country_BJ: 'Benin',
  country_BL: 'Saint Barthélemy',
  country_BM: 'Bermuda',
  country_BN: 'Brunei Darussalam',
  country_BO: 'Bolivia, Plurinational State of',
  country_BQ: 'Bonaire, Sint Eustatius and Saba',
  country_BR: 'Brazil',
  country_BS: 'Bahamas',
  country_BT: 'Bhutan',
  country_BV: 'Bouvet Island',
  country_BW: 'Botswana',
  country_BY: 'Belarus',
  country_BZ: 'Belize',
  country_CA: 'Canada',
  country_CC: 'Cocos (Keeling) Islands',
  country_CD: 'Congo, the Democratic Republic of the',
  country_CF: 'Central African Republic',
  country_CG: 'Congo',
  country_CH: 'Switzerland',
  country_CI: 'Côte d\'Ivoire',
  country_CK: 'Cook Islands',
  country_CL: 'Chile',
  country_CM: 'Cameroon',
  country_CN: 'China',
  country_CO: 'Colombia',
  country_CR: 'Costa Rica',
  country_CU: 'Cuba',
  country_CV: 'Cape Verde',
  country_CW: 'Curaçao',
  country_CX: 'Christmas Island',
  country_CY: 'Cyprus',
  country_CZ: 'Czech Republic',
  country_DE: 'Germany',
  country_DJ: 'Djibouti',
  country_DK: 'Denmark',
  country_DM: 'Dominica',
  country_DO: 'Dominican Republic',
  country_DZ: 'Algeria',
  country_EC: 'Ecuador',
  country_EE: 'Estonia',
  country_EG: 'Egypt',
  country_EH: 'Western Sahara',
  country_ER: 'Eritrea',
  country_ES: 'Spain',
  country_ET: 'Ethiopia',
  country_FI: 'Finland',
  country_FJ: 'Fiji',
  country_FK: 'Falkland Islands (Malvinas)',
  country_FM: 'Micronesia, Federated States of',
  country_FO: 'Faroe Islands',
  country_FR: 'France',
  country_GA: 'Gabon',
  country_GB: 'United Kingdom',
  country_GD: 'Grenada',
  country_GE: 'Georgia',
  country_GF: 'French Guiana',
  country_GG: 'Guernsey',
  country_GH: 'Ghana',
  country_GI: 'Gibraltar',
  country_GL: 'Greenland',
  country_GM: 'Gambia',
  country_GN: 'Guinea',
  country_GP: 'Guadeloupe',
  country_GQ: 'Equatorial Guinea',
  country_GR: 'Greece',
  country_GS: 'South Georgia and the South Sandwich Islands',
  country_GT: 'Guatemala',
  country_GU: 'Guam',
  country_GW: 'Guinea-Bissau',
  country_GY: 'Guyana',
  country_HK: 'Hong Kong',
  country_HM: 'Heard Island and McDonald Islands',
  country_HN: 'Honduras',
  country_HR: 'Croatia',
  country_HT: 'Haiti',
  country_HU: 'Hungary',
  country_ID: 'Indonesia',
  country_IE: 'Ireland',
  country_IL: 'Israel',
  country_IM: 'Isle of Man',
  country_IN: 'India',
  country_IO: 'British Indian Ocean Territory',
  country_IQ: 'Iraq',
  country_IR: 'Iran, Islamic Republic of',
  country_IS: 'Iceland',
  country_IT: 'Italy',
  country_JE: 'Jersey',
  country_JM: 'Jamaica',
  country_JO: 'Jordan',
  country_JP: 'Japan',
  country_KE: 'Kenya',
  country_KG: 'Kyrgyzstan',
  country_KH: 'Cambodia',
  country_KI: 'Kiribati',
  country_KM: 'Comoros',
  country_KN: 'Saint Kitts and Nevis',
  country_KP: 'Korea, Democratic People\'s Republic of',
  country_KR: 'Korea, Republic of',
  country_KW: 'Kuwait',
  country_KY: 'Cayman Islands',
  country_KZ: 'Kazakhstan',
  country_LA: 'Lao People\'s Democratic Republic',
  country_LB: 'Lebanon',
  country_LC: 'Saint Lucia',
  country_LI: 'Liechtenstein',
  country_LK: 'Sri Lanka',
  country_LR: 'Liberia',
  country_LS: 'Lesotho',
  country_LT: 'Lithuania',
  country_LU: 'Luxembourg',
  country_LV: 'Latvia',
  country_LY: 'Libya',
  country_MA: 'Morocco',
  country_MC: 'Monaco',
  country_MD: 'Moldova, Republic of',
  country_ME: 'Montenegro',
  country_MF: 'Saint Martin (French part)',
  country_MG: 'Madagascar',
  country_MH: 'Marshall Islands',
  country_MK: 'Macedonia, the former Yugoslav Republic of',
  country_ML: 'Mali',
  country_MM: 'Myanmar',
  country_MN: 'Mongolia',
  country_MO: 'Macao',
  country_MP: 'Northern Mariana Islands',
  country_MQ: 'Martinique',
  country_MR: 'Mauritania',
  country_MS: 'Montserrat',
  country_MT: 'Malta',
  country_MU: 'Mauritius',
  country_MV: 'Maldives',
  country_MW: 'Malawi',
  country_MX: 'Mexico',
  country_MY: 'Malaysia',
  country_MZ: 'Mozambique',
  country_NA: 'Namibia',
  country_NC: 'New Caledonia',
  country_NE: 'Niger',
  country_NF: 'Norfolk Island',
  country_NG: 'Nigeria',
  country_NI: 'Nicaragua',
  country_NL: 'Netherlands',
  country_NO: 'Norway',
  country_NP: 'Nepal',
  country_NR: 'Nauru',
  country_NU: 'Niue',
  country_NZ: 'New Zealand',
  country_OM: 'Oman',
  country_PA: 'Panama',
  country_PE: 'Peru',
  country_PF: 'French Polynesia',
  country_PG: 'Papua New Guinea',
  country_PH: 'Philippines',
  country_PK: 'Pakistan',
  country_PL: 'Poland',
  country_PM: 'Saint Pierre and Miquelon',
  country_PN: 'Pitcairn',
  country_PR: 'Puerto Rico',
  country_PS: 'Palestinian Territory, Occupied',
  country_PT: 'Portugal',
  country_PW: 'Palau',
  country_PY: 'Paraguay',
  country_QA: 'Qatar',
  country_RE: 'Réunion',
  country_RO: 'Romania',
  country_RS: 'Serbia',
  country_RU: 'Russian Federation',
  country_RW: 'Rwanda',
  country_SA: 'Saudi Arabia',
  country_SB: 'Solomon Islands',
  country_SC: 'Seychelles',
  country_SD: 'Sudan',
  country_SE: 'Sweden',
  country_SG: 'Singapore',
  country_SH: 'Saint Helena, Ascension and Tristan da Cunha',
  country_SI: 'Slovenia',
  country_SJ: 'Svalbard and Jan Mayen',
  country_SK: 'Slovakia',
  country_SL: 'Sierra Leone',
  country_SM: 'San Marino',
  country_SN: 'Senegal',
  country_SO: 'Somalia',
  country_SR: 'Suriname',
  country_SS: 'South Sudan',
  country_ST: 'Sao Tome and Principe',
  country_SV: 'El Salvador',
  country_SX: 'Sint Maarten (Dutch part)',
  country_SY: 'Syrian Arab Republic',
  country_SZ: 'Swaziland',
  country_TC: 'Turks and Caicos Islands',
  country_TD: 'Chad',
  country_TF: 'French Southern Territories',
  country_TG: 'Togo',
  country_TH: 'Thailand',
  country_TJ: 'Tajikistan',
  country_TK: 'Tokelau',
  country_TL: 'Timor-Leste',
  country_TM: 'Turkmenistan',
  country_TN: 'Tunisia',
  country_TO: 'Tonga',
  country_TR: 'Turkey',
  country_TT: 'Trinidad and Tobago',
  country_TV: 'Tuvalu',
  country_TW: 'Taiwan, Province of China',
  country_TZ: 'Tanzania, United Republic of',
  country_UA: 'Ukraine',
  country_UG: 'Uganda',
  country_UM: 'United States Minor Outlying Islands',
  country_US: 'United States',
  country_UY: 'Uruguay',
  country_UZ: 'Uzbekistan',
  country_VA: 'Holy See (Vatican City State)',
  country_VC: 'Saint Vincent and the Grenadines',
  country_VE: 'Venezuela, Bolivarian Republic of',
  country_VG: 'Virgin Islands, British',
  country_VI: 'Virgin Islands, U.S.',
  country_VN: 'Viet Nam',
  country_VU: 'Vanuatu',
  country_WF: 'Wallis and Futuna',
  country_WS: 'Samoa',
  country_YE: 'Yemen',
  country_YT: 'Mayotte',
  country_ZA: 'South Africa',
  country_ZM: 'Zambia',
  country_ZW: 'Zimbabwe',
  go_to_user_management: 'Go to user management',
  are_you_sure: 'Are you sure?',
  employment_active: 'Currently employed',
  delete: 'Delete',
  Number: 'Number',
  Bus: 'Bus',
  zipcode: 'Zipcode',
  must_be_alphanumeric: 'may only contain alphanumeric characters',
  select_a_filter: 'Saved filters',
  filter_name_empty: 'Filter name cannot be empty',
  delete_filter: 'Delete filter',
  settings: 'Settings',
  email_or_password_invalid: 'E-mail or password is invalid',
  please_provide_password: 'Please provide your password',
  delete_child: 'Delete child',
  add_comment_question: 'Add a comment/question',
  language: 'Language',
  user_search_result: '{amt} users found',
  recent_users: 'Showing recent users',
  find_a_user: 'Search users',
  user: 'User',
  managers: 'Managers',
  user_vitamins_are_being_loaded: 'Vitamins are being loaded',
  user_no_submissions_yet: 'This user has not submitted any vitamins yet',
  back_to_users: 'Back to user list',
  status: 'Status',
  teams: 'Teams',
  oneens_eens_1: 'Strongly disagree',
  oneens_eens_2: 'Disagree',
  oneens_eens_3: 'Somewhat disagree',
  oneens_eens_4: 'Neither agree nor disagree',
  oneens_eens_5: 'Somewhat agree',
  oneens_eens_6: 'Agree',
  oneens_eens_7: 'Strongly agree',
  nooit_altijd_1: 'Never',
  nooit_altijd_2: 'Very rarely',
  nooit_altijd_3: 'Rarely',
  nooit_altijd_4: 'Occasionally',
  nooit_altijd_5: 'Frequently',
  nooit_altijd_6: 'Very frequently',
  nooit_altijd_7: 'Always',
  ontevreden_tevreden_1: 'Very dissatisfied',
  ontevreden_tevreden_2: 'Dissatisfied',
  ontevreden_tevreden_3: 'Somewhat dissatisfied',
  ontevreden_tevreden_4: 'Neither satisfied nor dissatisfied',
  ontevreden_tevreden_5: 'Somewhat satisfied',
  ontevreden_tevreden_6: 'Satisfied',
  ontevreden_tevreden_7: 'Very satisfied',
  view: 'View',
  review: 'Review',
  tree: 'Structure',
  heatmap: 'Heat map',
  activity: 'Activity',
  more_details: 'More details',
  team_index: 'Team index',
  vip: 'VIP',
  submit_review: 'Submit review',
  stddev: 'Standard Deviation',
  delete_user: 'Delete user',
  comment_placeholder: 'You can enter comments or questions regarding {subcategory} here',
  vitamin_overview_for: 'Vitamins for {username}',
  back_to_userlist: 'Back to user list',
  unknown: 'Unknown',
  years_seniority: 'Years in employment',
  workingyears: 'Years in employment',
  demographics: 'Demographics',
  show_results_by_demographic: 'Results by demographic',
  choose_a_demographic: 'Choose a category',
  hide_submission: 'Submission visibility',
  passwords_no_match: 'Passwords do not match',
  add_as_member: 'Add user to team as member',
  add_as_manager: 'Add user to team as manager',
  no_results_yet: 'There is no data available',
  password_min_6_long: 'Your password must be at least 6 characters long',
  accesslevel: 'Access level',
  import_users: 'Import users',
  download_template: 'Download template',
  first_x_records: 'First {amt} records',
  maritalstatus: 'Marital state',
  Street: 'street',
  stateprovince: 'State/province',
  jobtitle: 'Job title',
  employmentstart: 'Start of employment',
  employmentend: 'End of employmeny',
  terminationreason: 'Termination reason',
  degreelevel: 'Education',
  modeoftransport: 'Mode of transport',
  x_invalid_rows: '{amt} invalid rows',
  $ERR_REQ:'This field is required!',
  $ERR_DATE:'Invalid date!',
  $ERR_INVALID:'Invalid!',
  x_records_processed:'{amt} records processed',
  x_users_imported_successfully:'{amt} users imported successfully',
  x_users_could_not_be_imported:'{amt} users could not be imported',
  the_following_errors_occurred:'The following errors occurred',
  row:'Row',
  click_to_add_csv:'Upload a .csv file',
  must_be_dmyyyy_or_iso:'Must be in DD/MM/YYYY or a valid ISO format',
  field_value_restrictions:'Valid values: {values}',
  invalid_country:'Must be a valid ISO 3166-1 alpha-2 country code',
  misc_server_error: 'An error has occurred',
  emailtaken_server_error: 'This e-mail is already in use',
  seniority_entry:'Entry-level',
  seniority_mid:'Mid-level',
  seniority_senior:'Senior',
  member_of:'Member of',
  admin_of:'Admin of',
  manager_of:'Manager of',
  remove_from_team:'Remove from team',
  expand_all: 'Expand all',
  collapse_all: 'Collapse all',
};

export default {
  message
}



// WEBPACK FOOTER //
// ./src/en.js